import { render, staticRenderFns } from "./MDDelYear.vue?vue&type=template&id=5cc63e10&"
import script from "./MDDelYear.vue?vue&type=script&lang=js&"
export * from "./MDDelYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports